// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3woWt","description":"PatientConsentPreview_description__1b8f2"};